// src/pages/LifeAtEdge.jsx
import React from "react";
import { useLangTranslation } from "../utils/translation";

export default function LifeAtEdge() {
  const t = useLangTranslation('lifeatedge');

  const workLifeFeatures = [
    { key: 'fourday' },
    { key: 'flexible' },
    { key: 'remote' },
    { key: 'noOvertime' },
    { key: 'horizontal' },
    { key: 'experiment' },
    { key: 'team' },
  ];

  return (
    <section className="life-section">
      {/* Hero 섹션 */}
      <div className="life-hero">
        <div className="life-hero-content">
          <h1 className="life-title">{t('hero.title')}</h1>
          <p className="life-subtitle">{t('hero.subtitle')}</p>
        </div>
      </div>

      {/* 본문 섹션 */}
      <div className="life-content">
        <div className="life-intro">
          <h2 className="life-intro-title">{t('intro.title')}</h2>
          <p className="life-intro-text">
            {t('intro.text')}
          </p>
        </div>

        {/* 특징 리스트 */}
        <div className="life-features">
          {workLifeFeatures.map((feature, index) => (
            <div key={index} className="life-feature-item">
              <span className="life-feature-icon">0{index + 1}</span>
              <p className="life-feature-text">{t(`features.${feature.key}`)}</p>
            </div>
          ))}
        </div>

        {/* 인용구 */}
        <div className="life-quote-section">
          <blockquote className="life-quote" dangerouslySetInnerHTML={{ __html: t('quote.text') }} />
        </div>
      </div>
    </section>
  );
}

